Drupal.behaviors.section = {
  attach(context) {
    const glider = context.querySelector(
      '.msl-section__column--slider .column-content',
    );

    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
    );

    function initGlider() {
      new Glider(glider, {
        slidesToShow: 1,
        slidesToScroll: 'auto',
        scrollLock: true,
        draggable: true,
        dots: context.querySelector('.dots'),
      });
    }

    if (glider && vw < 376) {
      if (
        document.readyState === 'complete' ||
        document.readyState === 'loaded' ||
        document.readyState === 'interactive'
      ) {
        initGlider();
      } else {
        document.addEventListener('DOMContentLoaded', initGlider);
      }
    }
  },
};
